/* iPhoneopladere.dk – cart drawer mobil fix v5 (via Claude)
   Mobil bruger temaets native #mini-cart. theme.js gen-renderer mini-cart-
   indholdet via innerHTML ved hver opdatering (og fyrer cart:rerendered),
   hvilket overskrev tidligere indsatte blokke. Derfor:
   - HTML for fragt-bar + upsell forudindlæses og caches (synkron indsætning,
     intet async-kapløb).
   - Genindsættes ved cart:rerendered / product:added + MutationObserver, så
     blokkene altid kommer tilbage EFTER temaets gen-rendering.
   Rent additivt – temaets egen kode røres ikke. */
(function () {
  var barHTML = '', upsHTML = '', threshold = 400, currentTotal = 0, cacheReady = false;
  var observer = null, injecting = false;

  function fmt(c) { return (c / 100).toFixed(2).replace('.', ',') + ' kr'; }

  function buildCache(html) {
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var bar = tmp.querySelector('#shipping-bar-wrapper');
    var ups = tmp.querySelector('.drawer-upsell-section');
    if (bar) {
      var th = parseInt(bar.getAttribute('data-threshold'), 10);
      if (th) threshold = th;
      bar.setAttribute('data-mc-bar', '');
      [['shipping-bar-text', 'data-mc-text'], ['shipping-bar-fill', 'data-mc-fill'], ['shipping-bar-amount', 'data-mc-amount'], ['shipping-bar-sub', 'data-mc-sub']].forEach(function (p) {
        var e = bar.querySelector('#' + p[0]);
        if (e) { e.removeAttribute('id'); e.setAttribute(p[1], ''); }
      });
      bar.removeAttribute('id');
      barHTML = bar.outerHTML;
    }
    if (ups) { upsHTML = ups.outerHTML; }
    cacheReady = !!(barHTML || upsHTML);
  }

  function refreshCache() {
    return fetch('/?section_id=drawer-cart').then(function (r) { return r.text(); }).then(buildCache).catch(function () {});
  }
  function refreshTotal() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { currentTotal = c.total_price; }).catch(function () {});
  }

  function populate(mc) {
    var w = mc.querySelector('[data-mc-bar]');
    if (!w) return;
    var th = (parseInt(w.getAttribute('data-threshold'), 10) || threshold) * 100;
    var t = mc.querySelector('[data-mc-text]'), f = mc.querySelector('[data-mc-fill]'), a = mc.querySelector('[data-mc-amount]'), s = mc.querySelector('[data-mc-sub]');
    if (!t || !f || !a || !s) return;
    var p = Math.min((currentTotal / th) * 100, 100);
    f.style.width = p + '%';
    a.textContent = fmt(currentTotal);
    if (currentTotal >= th) {
      t.innerHTML = 'Tillykke, du har fået gratis fragt! 🤩';
      f.parentElement.style.background = 'linear-gradient(90deg, #2ecd85, #00badb)';
      f.style.width = '100%';
      a.style.color = '#fff';
      a.style.textShadow = '0 1px 2px rgba(0,0,0,0.15)';
      s.textContent = 'Gratis fragt';
      s.style.color = '#2ecd85';
    } else {
      var rem = th - currentTotal;
      t.innerHTML = 'Du mangler <span style="color:#00badb">' + fmt(rem) + '</span> for gratis fragt 📦';
      f.parentElement.style.background = '#e1e3e4';
      a.style.color = p > 45 ? '#fff' : '#393e4c';
      a.style.textShadow = p > 45 ? '0 1px 2px rgba(0,0,0,0.15)' : 'none';
      s.textContent = 'Fri fragt ved ' + (th / 100) + ' kr';
      s.style.color = '#8a9297';
    }
  }

  function getMC() { return document.getElementById('mini-cart') || document.querySelector('.mini-cart'); }

  function inject() {
    if (!cacheReady || injecting) return;
    var mc = getMC();
    if (!mc) return;
    var content = mc.querySelector('.mini-cart__content') || mc.querySelector('.mini-cart__inner');
    if (!content) return;
    injecting = true;
    if (observer) observer.disconnect();
    try {
      if (!mc.querySelector('.drawer-upsell-section') && upsHTML) { content.insertAdjacentHTML('afterbegin', upsHTML); }
      if (!mc.querySelector('[data-mc-bar]') && barHTML) { content.insertAdjacentHTML('afterbegin', barHTML); }
      populate(mc);
    } finally {
      if (observer && mc) { observer.observe(mc, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-hidden', 'class'] }); }
      injecting = false;
    }
  }

  function injectSoon() { setTimeout(inject, 60); setTimeout(inject, 250); setTimeout(inject, 600); }

  function start() {
    ['cart:rerendered', 'cart:refresh', 'product:added', 'cart:updated'].forEach(function (ev) {
      document.addEventListener(ev, function () { refreshTotal(); refreshCache(); injectSoon(); }, false);
      document.documentElement.addEventListener(ev, function () { refreshTotal(); injectSoon(); }, false);
    });
    var mc = getMC();
    if (mc) {
      observer = new MutationObserver(function () { inject(); });
      observer.observe(mc, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-hidden', 'class'] });
    }
    Promise.all([refreshCache(), refreshTotal()]).then(function () { inject(); injectSoon(); });
    setTimeout(inject, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
